import React, { useState } from 'react';
import xMark from './assets/x-mark.svg';
import xMarkRed from './assets/x-mark-red.svg';
import eyeSlash from './assets/eye-slash.svg';
import eyeSlashRed from './assets/eye-slash-red.svg';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	error?: boolean;
	errorText?: string;
	clearable?: boolean;
	onClear?: () => void;
	passwordToggle?: boolean;
}

/**
 * Generic text Input with clear and password-toggle affordances.
 *
 * Styling depends on consumer-side CSS classes: `auth-input`,
 * `auth-input-wrapper`, `auth-input__clear`, `auth-restricted`,
 * `auth-input__clear-icon`. These must be defined by the host app.
 */
export const Input: React.FC<InputProps> = ({
	className = '',
	error = false,
	errorText,
	disabled,
	clearable = false,
	onClear,
	passwordToggle = false,
	type = 'text',
	value,
	...props
}) => {
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);

	const hasError = error || Boolean(errorText);
	const hasValue = typeof value === 'string' ? value.trim().length > 0 : Boolean(value);
	const isPasswordField = passwordToggle && type === 'password';
	const inputType = isPasswordField ? (isPasswordVisible ? 'text' : 'password') : type;

	const classes = ['auth-input', hasError ? 'is-error' : '', disabled ? 'is-disabled' : '', className]
		.filter(Boolean)
		.join(' ');

	return (
		<div className="auth-input-wrapper">
			<input className={classes} disabled={disabled} type={inputType} value={value} autoComplete="username" {...props} />

			{!isPasswordField && clearable && hasValue && onClear && (
				<button type="button" className="auth-input__clear" onClick={onClear} aria-label="Очистить поле" disabled={disabled}>
					<img src={hasError ? xMarkRed : xMark} alt="" className="auth-input__clear-icon" />
				</button>
			)}

			{isPasswordField && (
				<button type="button" onClick={() => setIsPasswordVisible((prev) => !prev)} className="auth-restricted" disabled={disabled}>
					<img src={hasError ? eyeSlashRed : eyeSlash} alt="Показать/Скрыть" />
				</button>
			)}
		</div>
	);
};
